import { EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/sharedService';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';

export class DialogCommunicator {
  dialogEntity: any;
  public updateRequested = false
  updateEntityEmitter: EventEmitter<any> = new EventEmitter();
  dialog: MatDialog;
  constructor(
   
    public dialogRef: MatDialogRef<DialogCommunicator>,
    public sharedService: SharedService) {

  }


  setConfirmationDialog(dialog: MatDialog) {
    this.dialog = dialog
  }

  setEntity<T>(entity: T) {
    this.dialogEntity = entity
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
  onModifyStateClick(dialogText: any, action: any): void {
      const dialogRefConf = this.dialog.open(ConfirmationDialogComponent, {
        width: '500px',
        data: { text: "DIALOG." + dialogText, emitter: this.sharedService.updateEntity, obj: this.dialogEntity, action: action }
      });
      dialogRefConf.afterClosed().subscribe(result => {
        if (result) {
          if (action==='DEACTIVATE'){
            this.sharedService.deactivateEntity(this.dialogEntity)
          }
          else if (action==='DECLINE'){
            this.sharedService.declineEntity(this.dialogEntity)
          }
          else if (action==='SUSPEND'){
            this.sharedService.suspendEntity(this.dialogEntity)
          }
          else{
            this.sharedService.activateEntity(this.dialogEntity)
          }
          
          this.dialogRef.close();
        } else {
          this.dialogRef.close();
        }
      });
    
  }
    
  onUpdateClick(action: any, dialogText: any): void {
    this.updateRequested = true
    if (this.dialogEntity.id) {
      const dialogRefConf = this.dialog.open(ConfirmationDialogComponent, {
        width: '500px',
        data: { text: "DIALOG." + dialogText, emitter: this.sharedService.updateEntity, obj: this.dialogEntity, action: action }
      });
      dialogRefConf.afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close();
        }
      });
    }
    else {
      if (['UPDATE_CASH_PAYMENT', 'FILL_BALANCE', 'POLICE_TAX'].includes(dialogText)){
        this.dialogEntity['DIALOG'] = this.dialogRef
      }else{
        this.dialogRef.close();
      }
      this.sharedService.updateEntity(this.dialogEntity)
    }
  }

  onVisitStatusChange(dialgoText: String, action: string, apiResource: String): void {
    const dialogRefConf = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { text: dialgoText, obj: this.dialogEntity, action: action }
    });
    dialogRefConf.afterClosed().subscribe(result => {
      if (result) {
        this.sharedService.updateVisit({ patch_state: true, id: this.dialogEntity.id, status: apiResource })
        this.dialogRef.close();
      }
    });
  }

}
